import {NgModule} from '@angular/core';
import {LoginPageComponent} from './login-page.component';
import {PageCommonModule} from '../shared/page-common.module';
import {ForgotLoginPageComponent} from './forgot/forgot-login-page.component';
import {ResetPasswordPageComponent} from './reset-password/reset-password-page.component';
import {FormsModule} from '../../components/forms/forms.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [
        PageCommonModule,
        FormsModule,
        NgbModule
    ],
    declarations: [
        LoginPageComponent,
        ForgotLoginPageComponent,
        ResetPasswordPageComponent
    ]
})
export class LoginPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/login/login-page.module.ts